import { render, staticRenderFns } from "./LogoSwitcher.vue?vue&type=template&id=bbfa3772&scoped=true&"
import script from "./LogoSwitcher.vue?vue&type=script&lang=js&"
export * from "./LogoSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./LogoSwitcher.vue?vue&type=style&index=0&id=bbfa3772&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfa3772",
  null
  
)

export default component.exports